import React from "react";
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as utilities from "./utilities";
import * as globals from "../globals";
import Masonry from "react-masonry-component";

import CaseCounter from "../CaseCounter";
import TwitterFeed from "../TwitterFeed";
import StoryList from "../StoryList";
import GoogleForm from "../GoogleForm";
import InfoCard from "../InfoCard";
import QA from "../QA";

export default class InfoGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.masonryProps = {
      itemSelector: ".grid-item",
      stamp: ".stamp"
    };
  }

  render() {
    return (
      <Masonry
        ref={function(c) {
          this.masonry = this.masonry || c.masonry;
        }.bind(this)}
        className={"grid"} // default ''
        options={this.masonryProps} // default {}
        disableImagesLoaded={false} // default false
        updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
        css={css`
          .grid-item {
            padding: 6px;
          }
          .grid-sizer,
          .grid-item {
            width: 50%;
          }
          @media (max-width: 800px) {
            .grid-sizer,
            .grid-item {
              width: 100%;
            }
          }
          @media (max-width: 600px) {
            .grid-sizer,
            .grid-item {
              width: 100%;
            }
          }
        `}
      >
        <div className="grid-sizer"></div>
        <div className="grid-item">
          <CaseCounter cases={this.props.info.cases}></CaseCounter>
        </div>
        <div className="grid-item">
          <StoryList stories={this.props.info.recap} header={"RECAP"} />
        </div>
        <div className="grid-item">
          <TwitterFeed />
        </div>
        <div className="grid-item">
          <InfoCard tips={this.props.info.tips} />
        </div>
        <div className="grid-item">
          <QA qas={this.props.info.qa} />
        </div>
        <div className="grid-item">
          <GoogleForm />
        </div>
      </Masonry>
    );
  }
}
